import { Button, Result } from "antd-mobile";
import { FC } from "react";
import CenterContent from "../layouts/CenterContent";

interface IProps {
  title: string;
  onRetry(): void;
}

const ErrorWithRetry: FC<IProps> = ({ title, onRetry }) => {
  return (
    <CenterContent>
      <Result
        status="error"
        title={title}
        description={
          <Button color="primary" onClick={onRetry}>
            Try again
          </Button>
        }
      />
    </CenterContent>
  );
};

export default ErrorWithRetry;
